var DONEGDPRParams = {
    color: '#B7D144',
    lang: jQuery('html').attr('lang').substr(0, 2),
    policy_url: ajax.privacyurl,
    groups: {
        always_active: [{
            name: 'Google (NID, CONSENT, P_JAR, HSID, APISID, SAPISID, SID, SIDCC, SSID)'
        }, {
            name: 'eactsolutions.hu own cookies (PHPSESSID, DONEGDPRConsent, DONEGDPRAlertBoxClosed, _icl_current_language)'
        }],
        targeting: [{
            name: 'Google Analytics (_ga, _gat, _gid)',
        }, {
            name: 'Google Tag Manager (_dc_gtm_UA-#)',
        }],
    }
};

function setCookie(name, value, expiryDays, domain, path) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + (expiryDays || 365));

    var cookie = [
        name + '=' + value,
        'expires=' + exdate.toUTCString(),
        'path=' + (path || '/')
    ];

    document.cookie = cookie.join(';');
};

function setAlertBoxClosed() {
    var b = (new Date).getTime();
    setCookie("DONEGDPRAlertBoxClosed", b, 365);
};

(function ($) {
    $(() => {

        $.cookieSettings = Cookies.get('DONEGDPRConsent');

        if ($.cookieSettings != undefined) {
            $.cookieSettings = JSON.parse($.cookieSettings);
        } else {
            setCookie('DONEGDPRConsent', JSON.stringify({"functional": false, "performance": false, "targeting": true}), 365);
            $(".done-gdpr-alert-box-wrapper").addClass('active')
        }

        var gtm = 'GTM-NPCTKN2';
        if (window.location.hostname != "eactsolutions.hu") {
            gtm = 'GTM-NPCTKN2';
        }

        if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
            window[`ga-disable-${gtm}`] = false;

            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }

            gtag('js', new Date());
            gtag('config', gtm);
        } else {
            window[`ga-disable-${gtm}`] = true;

            var cookies = Cookies.get();

            if ('' !== cookies) {

                $.each(cookies, function (index) {

                    index = '' + index;

                    if ('_ga' === index || '_gid' === index || '_gat' === index) {
                        Cookies.remove(index, { domain: document.domain });
                    }

                });

            }
        }

        $(document).on('click', '.js-open-cookie a', function (e) {
            e.preventDefault();
            cookiedone.showCookieSettings();

            if ($.cookieSettings != undefined && $.cookieSettings.performance == true) {
                $('.done-gdpr-status-checkbox.performance').attr('checked', true)
            }
            if ($.cookieSettings != undefined && $.cookieSettings.targeting == true) {
                $('.done-gdpr-status-checkbox.targeting').attr('checked', true)
            }
        });

        $(document).on('click', '#done-gdpr-save-button', function (e) {
            location.reload();
        });

        $(document).on('click', '.done-gdpr-button-allow', function (e) {
            e.preventDefault();
            e.stopPropagation();
            cookiedone.allowAll();
            location.reload();
        });
    });


})(jQuery);